export default "__VITE_ASSET__C74ivKNm__"